// Runs before the app's own code (see Next's instrumentation-client docs).
// Only starts PostHog when the user already granted analytics consent on a
// previous visit (a saved `analytics_consent` cookie) — first-visit gating
// happens live via the consent banner's own callbacks instead (see
// components/cookie-consent-banner.tsx).
import { initAnalyticsIfConsented } from "@/lib/analytics";

initAnalyticsIfConsented();
